import * as React from "react";
/**
 * currentPage - The number of the page which should be displayed at the moment. Should be between 1 and xyz.
 * totalPages - The number of pages which exists. Should be between 0 and xyz
 * onClick - Is a CallBack Arrow Function. Will be called by parent control
 * text - The text which represents all relevant information for the user. May contain any content. E.g. <noOfVisibleElementFrom> - <noOfVisibleElementTo> / <noOfAllElements>
 */
export type CpbxPaginationSimpleProps = {
    currentPage: number;
    totalPages: number;
    onClick: (x) => void;
    text: string;
}
const CpbxPaginationSimple = ({ currentPage, totalPages, onClick, text }:CpbxPaginationSimpleProps) => {

    if (currentPage === undefined || currentPage === null || isNaN(currentPage) || currentPage < 1 || currentPage > totalPages) {
        console.log("Ungültige Parameter von 'currentPage: '" + currentPage + "'");
        return (<div>Es ist ein Fehler aufgetreten. (Unerwarteter Parameterwert für &apos;currentPage&apos;</div>);
    }

    if (totalPages >= 15000 || currentPage >= 15000) {
        console.log("Maximalwert soll weniger als 15.000 Seiten sein. CurrentPage = '" + "'" + currentPage + "'. " + "TotalPages" + totalPages);
        return (<div>Maximalwert ist überschritten</div>);
    }

    if (totalPages === undefined || totalPages === null || isNaN(currentPage) || totalPages < currentPage) {
        console.log("Ungültige Parameter von 'totalPages: '" + totalPages + "'");
        return (<div>Es ist ein Fehler aufgetreten. (Unerwarteter Parameterwert für &apos;totalPages&apos;</div>);
    }

    if (onClick === undefined || onClick === null) {
        console.log("Ungültige Funktion 'onClick:'", onClick, "'");
        return (<div>Es ist ein Fehler aufgetreten. (Ungültige Funktion &apos;onClick&apos;</div>);
    }

    if (text === undefined || text === null || typeof (text).toLowerCase() !== "string") {
        console.log("Ungültige Parameter in ´text: ´" + text + "´");
        return (<div>Es ist ein Fehler aufgetreten. (Unerwarteter Parameterwert für &apos;text&apos;</div>);
    }

    return (
        <div className="cpbxPaginationSimple">
            <button id="prevPage" title="Die ersten Einträge anzeigen." className="btn" disabled={currentPage <= 1} onClick={() => onClick(1)}>{"<<"}</button>
            <button id="nextPage" title="Die vorherigen 7 Einträge anzeigen." className="btn" disabled={currentPage <= 1} onClick={() => onClick(currentPage - 1)}>{"<"}</button>
            <span className="cpbxDirectoryPagination"> {text} </span>
            <button id="prevPage" title="Die nächsten 7 Einträge anzeigen." className="btn" disabled={currentPage >= totalPages} onClick={() => onClick(currentPage + 1)}>{">"}</button>
            <button id="nextPage" title=" Die letzten Einträge anzeigen." className="btn" disabled={currentPage >= totalPages} onClick={() => onClick(totalPages)}>{">>"}</button>
        </div>
    );
};

export default CpbxPaginationSimple;
